import styled from "styled-components";
import mediaQuery, { Screen } from "../../Utilities/MediaQuery";
import { ifProp, prop, theme } from "styled-tools";

export const CardStep = styled.div<{ text?: string }>`
  width: 100%;
  height: auto;
  max-height: ${ifProp("!text", "292px", "")};
  background-color: ${theme("Bright_Gray")};
  display: flex;
  flex-direction: row;

  div {
    align-items: center;
  }

  ${mediaQuery[Screen.lg]} {
    img {
      width: 470px;
    }
  }
  ${mediaQuery[Screen.xl]} {
    img {
      width: 550px;
    }
  }

  ${mediaQuery[Screen.mobile]} {
    display: none;
  }
`;

export const CardStepMovile = styled.div<{ text?: string }>`
  height: auto;
  background-color: ${theme("White")};
  display: flex;
  flex-direction: column;
  margin: 24px 0;
  justify-content: center;
  border-bottom: 2px solid
    ${ifProp(prop("text"), theme("Amaranth_Red"), theme("White"))};
  margin-inline: 24px;

  p {
    margin: 12px 0;
  }

  ${mediaQuery[Screen.desktop]} {
    display: none;
  }
`;
